import React from 'react';
import classnames from 'classnames';

import './contentView.scss';

interface Props {
  className?: string;
  children?: React.ReactNode;
}

const ContentView: React.FC<Props> = (props: Props) => {
  const wrapperClasses = classnames('content-view-component', props.className);
  return <div className={wrapperClasses}>{props.children}</div>;
};

export default ContentView;
